import React, { useState, useCallback } from 'react';
import {
	autoUpdate,
	flip,
	FloatingPortal,
	useClick,
	useDismiss,
	useFloating,
	useInteractions,
	useRole,
	size,
	Placement,
} from '@floating-ui/react';
import style from './CustomPop.module.scss';

interface IProps {
	children: React.ReactNode;
	childrenContent: React.ReactNode;
	placement?: Placement;
	setOpenStatus?: (value: boolean) => void;
}

export const CustomPop: React.FC<IProps> = React.memo(
	({ children, childrenContent, placement = 'bottom-end', setOpenStatus }) => {
		const [open, setOpen] = useState(false);

		const handleOpenChange = useCallback((value: boolean) => {
			setOpen(value);
			setOpenStatus && setOpenStatus(value);
		}, []);

		const { x, y, strategy, context, refs } = useFloating({
			open,
			onOpenChange: handleOpenChange,
			whileElementsMounted: autoUpdate,
			placement,
			middleware: [
				flip(),
				size({
					apply({ elements, availableHeight }) {
						Object.assign(elements.floating.style, {
							maxHeight: `${availableHeight}px`,
						});
					},
				}),
			],
		});

		const { getReferenceProps, getFloatingProps, getItemProps } = useInteractions([
			useClick(context, { event: 'click' }),
			useDismiss(context),
			useRole(context, { role: 'tree' }),
		]);

		return (
			<>
				<div
					{...getReferenceProps({
						ref: refs.setReference,
						onClick(e) {
							e.stopPropagation();
						},
					})}>
					{children}
				</div>
				{open && (
					<FloatingPortal>
						<div
							onClick={(e) => e.stopPropagation()}
							{...getFloatingProps({
								ref: refs.setFloating,
								style: {
									position: strategy,
									// top: y + 2,
									top: y ?? 0,
									left: x ?? 0,
									zIndex: 5,
								},
							})}>
							<div
								className={style.contentWrapper}
								{...getItemProps({
									onClick: () => {
										setOpen(false);
										setOpenStatus && setOpenStatus(false);
										// onEdit();
									},
								})}>
								{childrenContent}
							</div>
						</div>
					</FloatingPortal>
				)}
			</>
		);
	},
);
